import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { useQuery } from '@tanstack/react-query';

import styles from './Dashboard.module.css';
import { OutstandingLoanView } from './outstandingLoanView/OutstandingLoanView';
import { useStateKey } from '../../../iwQueryClient/useStateKey';
import { useTrackPageView } from '../../../tracking/pageView';
import ApplyFlexiLoanInfoView from '../../applyFlexiLoanView/ApplyFlexiLoanInfoView/ApplyFlexiLoanInfoView';
import MainContentPending from '../../pageStructure/mainContentPending/index';

const Dashboard = () => {
    useTrackPageView({ name: 'CBILS Dashboard' });

    const stateKey = useStateKey();
    const { isLoading, data: getAccountsResponse } = useQuery(
        getAccountsQueryConfig(stateKey)
    );

    if (isLoading) {
        return <MainContentPending data-testid="cbils-dashboard-loading" />;
    }

    if (getAccountsResponse && getAccountsResponse.data) {
        let dashboardStatus: 'offered' | 'ineligible' = 'ineligible';

        const firstCBILSLoan = getAccountsResponse.data.accounts.find(
            (account) => account.product_type === 'cbils'
        );

        if (firstCBILSLoan) {
            if (
                ['ongoing', 'topup', 'overdue', 'duetoday'].includes(
                    firstCBILSLoan.loan_status!
                )
            ) {
                dashboardStatus = 'offered';
            }

            switch (dashboardStatus) {
                case 'offered':
                    return (
                        <div className={styles.Dashboard}>
                            <OutstandingLoanView account={firstCBILSLoan} />
                        </div>
                    );

                default:
                    return <ApplyFlexiLoanInfoView />;
            }
        }
        return <ApplyFlexiLoanInfoView />;
    }
    return null;
};

export const CBILSDashboard = Dashboard;
